import React from "react";
import { useState, useEffect, useCallback } from "react";
import { useLocation, Route, Routes, Navigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import icon_square from "../assets/img/icons/common/icon_square.svg";
import { CMM } from '../Lib/Cmm.js';
import axios from 'axios';

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";

let user_idx;
let u_uuid;

const storedComp_nm = sessionStorage.getItem('comp_nm');
const storedName = sessionStorage.getItem('name');
const storedInfo = sessionStorage.getItem('info');

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  const pathname = location.pathname;
  const match = pathname.match(/\/([^\/]+)$/);

  // console.log(pathname);

  u_uuid = match[1];

  const [comp_nm, setComp_nm] = useState('');
  const [name, setName] = useState('');
  const [info, setInfo] = useState('');
  const [img, setImg] = useState('');

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
    getProfile();
  }, [location]);

  //챗봇 프로필 업데이트
  const getProfile = useCallback(() => {

    axios.get(`${CMM.SERVER_URL_API}/chat/get_user_idx?u_uuid=${u_uuid}`)
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);

          user_idx = res.data.message[0].user_idx;

          //세션 스토리지에 데이터 저장
          sessionStorage.setItem('user_idx', res.data.message[0].user_idx);
          sessionStorage.setItem('u_uuid', u_uuid);

          axios.get(`${CMM.SERVER_URL_API}/chat/chatbot_profile?user_idx=${user_idx}`)
            .then((res) => {
              if (res != 'ERROR') {

                // console.log(res.data.message[0]);

                sessionStorage.setItem('comp_nm', res.data.message[0].comp_nm);
                sessionStorage.setItem('name', res.data.message[0].name);
                sessionStorage.setItem('info', res.data.message[0].info);
                sessionStorage.setItem('img', res.data.message[0].image);

                setComp_nm(res.data.message[0].comp_nm);
                setName(res.data.message[0].name);
                setInfo(res.data.message[0].info);
                setImg(res.data.message[0].image);

              }
            })
            .catch((e) => {
              return 'ERROR';
            })

        }
      })
      .catch((e) => {
        return 'ERROR';
      })
  }, [u_uuid, comp_nm, name, info, img])

  return (
    <>
      <div className=" h-100 " ref={mainContent} style={{ backgroundColor: '#FCFBFB', height: '100vh' }}>
        <span
          className="px-4 py-4"
          style={{ fontWeight: 'bold', color: '#000000', fontSize: '24px', display: 'block' }}
        >{comp_nm}</span>
        <div className="text-center">
          <Card className="bg-secondary shadow mx-3 bg-white" style={{ borderRadius: '20px' }}>
            <CardHeader className=" border-0" style={{ borderRadius: '20px' }}>

              <Row className="align-items-center">
                <img src={`${CMM.SERVER_URL_API}/files/${img}`} width="55" height="55" style={{ borderRadius: '15px' }} />
                <span
                  className="px-2"
                  style={{ fontWeight: 'bold', color: '#000000', fontSize: '16px', display: 'block', }}
                >{name}</span>
              </Row>
              <span
                className="py-4 px-4"
                style={{ color: '#000000', fontSize: '16px', display: 'block' }}
              >{info}</span>
              <Link to="/chatbot/ChatPage" style={{ color: 'white' }}>
                <Button
                  style={{ backgroundColor: '#0591D9', color: 'white', border: 'none' }}
                  className="px-6"
                >
                  <span style={{ marginLeft: "5px" }}>문의하기</span>
                  <FontAwesomeIcon icon={faPaperPlane} />
                </Button>
              </Link>
            </CardHeader>
          </Card>
          <span
            className="py-2"
            style={{ fontWeight: 'bold', color: '#777777', fontSize: '12px', display: 'block' }}
          >박대리 채용하기</span>
        </div>
      </div >
    </>
  );
};

export default Auth;
